export default "__VITE_ASSET__B2zmgae7__"